<template>
  <q-card flat class="q-pa-md full-height full-width">
    <q-card-section>
      <p>
        <a href="https://www.ilect.net/" target="_blank" rel="noopener">
          iLect CL
        </a>
        {{ t("views.about.description") }}
      </p>
    </q-card-section>

    <q-card-section>
      <p>
        <router-link to="/privacy-policy">
          {{ t("views.about.privacy") }}
        </router-link>
      </p>
    </q-card-section>
  </q-card>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
